<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Pending Truck Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Pending Truck Details",
            items: [
               {
                  text: "Trucks",
                  href: "/trucks",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],
            truck: {
               fuel_station: [], 
            },
            token: "",
            errors: {}, 
            password: "",
            password_confirmation: "",

         };
      },
      mounted() {
    
      },
      created() {
         this.fetchTruck();
      },

      methods: {
         fetchTruck() {
            let url = "api/admin/driver/pending_trucks/details?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if(res.status == 200) {
               var responseData = res.data.data;
               console.log(responseData);
               this.truck = responseData.trucks;
               }  
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         getToken() {
         if (localStorage.getItem('sigofuel_admin')) {
            var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
            if(sigofuel_admin.token) {
               this.token = sigofuel_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-6">
                

                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">
                                 <a :href="$image_url + truck.mot_certificate_url" target="_blank"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> MOT Certificate</p></a>  
                              </li>

                              <li class="mb-3">
                                 <a :href="$image_url + truck.insurance_certificate_url" target="_blank"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Insurance Certificate</p></a>  
                              </li>

                              <li class="mb-3">
                                 <a :href="$image_url + truck.truck_certificate_url" target="_blank"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Truck Certificate</p></a>  
                              </li>
                           </ul>
                        </b-card>

                        <div class="d-grid gap-2">                           
                            
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-15 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Fuel Station Details</h4>

                           <div class="row">
                              <div class="col-12">
                                 <b-media class="mb-1">
                                    <template v-slot:aside>
                                       <img src="@/assets/images/crypto/blog/img-1.jpg" alt class="avatar-md rounded"/>
                                       <br>
                                    </template>
                                    <b-media-body class="ms-3">
                                       <h5 class="mt-1 mb-1">
                                  {{truck.fuel_station_name_en}} </h5>
                                  <h5 class="mt-1 mb-1">
                                  {{truck.fuel_station_name_so}}
                                  </h5>
                                       <p>
                                          {{truck.country_code}} {{truck.fuel_station_mobile}}<br>
                                          {{truck.fuel_station_email}}
                                       </p>
                                    </b-media-body>
                                 </b-media>
                              </div>
                           </div>    

                           <div class="table-responsive ">
                              <table class="table table-nowrap mb-0">
                                 <tbody>
                                    <tr>
                                       <th scope="row">Latitude</th>
                                       <th>:</th>
                                       <td>{{truck.fuel_station.latitude}}</td>
                                    </tr> 

                                    <tr>
                                       <th scope="row">Longitude</th>
                                       <th>:</th>
                                       <td>{{truck.fuel_station.longitude}}</td>
                                    </tr>  

                                    <tr>
                                       <th scope="row">Address</th>
                                       <th>:</th>
                                       <td>
                                          <p style="max-width: 100px;">{{truck.fuel_station.address}}</p>
                                       </td>
                                    </tr>  
                                 </tbody>
                              </table>
                           </div>                     
                        </b-card>      

                     </div>

                     <div class="col-lg-7 col-md-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Truck Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       
                                       <tr>
                                          <th width="45%">Truck No.</th>
                                          <th width="5%">:</th>
                                          <td width="50%">{{truck.truck_no}}</td>
                                       </tr> 

                                       <tr>
                                          <th>Manufacturer</th>
                                          <th>:</th>
                                          <td>{{truck.manufacturer}}</td>
                                       </tr>

                                       <tr>
                                          <th>Manufactured Year</th>
                                          <th>:</th>
                                          <td>{{truck.manufactured_year}}</td>
                                       </tr>

                                       <tr>
                                          <th>Model</th>
                                          <th>:</th>
                                          <td>{{truck.model}}</td>
                                       </tr>

                                       <tr>
                                          <th>Colour</th>
                                          <th>:</th>
                                          <td>{{truck.color}}</td>
                                       </tr>

                                       <tr>
                                          <th>Chassis No.</th>
                                          <th>:</th>
                                          <td>{{truck.chassis_no}}</td>
                                       </tr>

                                       <tr>
                                          <th>Engine No.</th>
                                          <th>:</th>
                                          <td>{{truck.engine_no}}</td>
                                       </tr>

                                       <tr>
                                          <th>Created on</th>
                                          <th>:</th>
                                          <td>{{truck.converted_created_at}}</td>
                                       </tr>   
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

   </Layout>
</template>
